export * from './canIUse';
export * from './envInfo';
export * from './goTo';
export * from './internal';
export * from './locate';
export * from './login';
export * from './omega';
export * from './query';
export * from './request';
export * from './resapi';
export * from './saveImg';
export * from './statistic';
export * from './storage';
export * from './webx';
export * from './xenv';
export * from './launchApp';
export * from './utils';
export * from './perfTrack';
export * from './version';
export * from './dchnBatchProcess';
import utils from './utils';
export { utils };
